module.exports = __webpack_public_path__ + "d71756dabd112dfa6509fbee48ef9d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile/Hosokawa.jpg
// module id = 98
// module chunks = 0